import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `50% ${theme.spacing.space48}px 0`,
  },
  desc: {
    marginBottom: 20,
  },
  btn: {
    textTransform: "capitalize",
  },
}));
